import dodologo from '../assets/images/dododotlog.png';
import { Flex, Image, useBreakpointValue, Card, CardHeader, Text, Spacer, CardBody, HStack, Button} from '@chakra-ui/react';
import kcookingtrip from '../assets/images/kcookingtrip.png';
import googlebtn from '../assets/images/google_btn.png';
import applebtn from '../assets/images/apple_btn.svg';
import { useNavigate } from "react-router-dom";

function Home() {
  
  const imgSizeLogo = useBreakpointValue({ base: "40%", md: "20%" });
  const imgSize = useBreakpointValue({ base: "50%", md: "25%" });

  const navigate = useNavigate();

  const redirectToURL = () => {
    window.location.href = "https://kcookingtrip.onelink.me/YWsf/upisfprg";
  };


  return (
    <Flex direction="column"
          alignItems="center" 
          flex="1"
          bgColor="#646AB0" >
      <br />
      {/* KCooking Trip */}
      <Card maxW="sm" overflow="hidden" padding={2}>
      <Image
        src={kcookingtrip}
        alt="k-cookingtrip"
      />
      <CardHeader>
        <Text fontSize="xl" fontWeight="bold" cursor="pointer" _hover={{ textDecoration: "underline" }} onClick={() => navigate("/kcookingsupport")}>
          K-CookingTrip</Text>
      </CardHeader>

      {/* 버튼을 카드 안쪽에 배치 */}
      <CardBody>
          <HStack spacing={6} justify="center">
            <Button onClick={redirectToURL} variant="unstyled">
              <Image src={applebtn} alt="Button 1" width="140px" />
            </Button>
            <Button onClick={redirectToURL} variant="unstyled">
              <Image src={googlebtn} alt="Button 2" width="140px" />
            </Button>
          </HStack>
        </CardBody>

      </Card>
      <br />
    </Flex>
  );
}


export default Home;
